import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { MembershipService } from '@app/services/membership.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Membership } from '@app/models/membership';
import { AuthService } from '@app/services/auth/auth.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MemberService } from '@app/services/member.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-membership',
  templateUrl: './membership.component.html',
  styleUrls: ['./membership.component.css']
})
export class MembershipComponent implements OnInit, OnDestroy {
  @Input() givenname: string;
  @Input() familyname: string;
  @Input() memberId;
  @Input() primarylodgeformember: number;
  @Input() showall: boolean;
  @Input() isClerk: boolean;
  @Input() isSysAdmin: boolean;
  @Input() isadminformember: boolean;
  @Input() time: number;
  @Output() doChangePrimaryInstitution = new EventEmitter();
  @Output() doTerminate = new EventEmitter();
  mobiledevice = false;
  memberships: Membership[] = [];
  subscriptions: Subscription[] = [];
  memberid;
  editmembership = false;
  editmembershipdate = false;
  addmembership = false;
  changeprimaryinstitution = false;
  terminatemembership = false;
  terminatemembershipcamp = false;
  membershipedit: Membership;

  selectedrole;

  can_change_primary_institution = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    private memberService: MemberService,
    private membershipService: MembershipService,
    private router: Router,
    private authService: AuthService,
    private permissionService: PermissionsService,
  private confirmationService: ConfirmationService) {
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {
    this.permissionService.selectedrole.subscribe(role => {
      if (role) {
      this.selectedrole = role;
      this.setPermissions();
      }
    });

    this.activatedRoute.paramMap.subscribe(paramMap => {
      this.memberid = +paramMap.get('id');
      //this.setPermissions();
      this.getMemberships();
      this.editmembership = false;
      this.addmembership = false;
      this.changeprimaryinstitution = false;
      this.terminatemembership = false;
      this.terminatemembershipcamp = false;
    });
    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });
  }

  terminateMembership2(membership) {
    this.doTerminate.emit(membership);
  }

  getMemberships() {
    this.subscriptions.push(this.membershipService.getMembershipByMemberId(this.memberid).subscribe(memberships => {
      if (memberships) {
        this.memberships = memberships;
        const activememberships = this.memberships.filter(m => m.endDate.startsWith('9999'));
        const activemembershipsid: any[] = [];
        activememberships.forEach(m => activemembershipsid.push(m.institutionId));
        this.permissionService.memberinstitutions = activemembershipsid;
        this.permissionService.setMemberAccess();
      }
    }));
  }

  confirmDeleteMembership(membership) {
    const data = {
      memberId: membership.memberId,
      institutionId: membership.institutionId
    };
    this.membershipService.getOfficesAndSignsStatusForMembership(data).subscribe(resp => {
      if (resp?.length > 0 && resp[0].rowsAffected !== 0) {
        this.confirmDialog();
      } else {
        this.confirmDialog2(membership);
      }
    });
  }

  confirmDialog2(membership): void {
     this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Är du säker på att du vill radera medlemskapet i ' + membership.institution.shortName + ' ' + membership.institution.name + '?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.deleteMembership(membership);
      },
      reject: () => {
      }
    });
  }

  deleteMembership(membership) {
    const data = {
      membershipId: membership.id,
      memberId: membership.memberId,
      institutionId: membership.institutionId,
      action: 'delete'
    };
    const dataarr = [];
    dataarr.push(data);
    this.subscriptions.push(this.memberService.updateMemberMembership(dataarr).subscribe(response => {
      if (response) {
        this.snackbarService.openSnackBar('Medlemskapet raderat', null);
        this.getMemberships();
      }
    }));
  }

  confirmDialog(): void {
     this.confirmationService.confirm({
      header: 'Information',
      message: 'Uppdrag och Utmärkelser kopplade till aktuellt medlemskap måste raderas först.',
      acceptLabel: 'Ok',
      rejectVisible: false, 
      accept: () => {
       
      }
    });

  }

  setPermissions() {
    /*this.permissionService.hasPermissionForMember('CHANGE_PRIMARY_INSTITUTION', this.memberid).subscribe(resp => {
      this.can_change_primary_institution = resp;
    });*/
      const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_change_primary_institution = user_permissions.indexOf('CHANGE_PRIMARY_INSTITUTION') !== -1;
  }

  edit(membership: any) {
    this.membershipedit = membership;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  closeEdit(evt: any) {
    this.editmembership = false;
    this.getMemberships();
  }

  closeAdd(evt: any) {
    this.addmembership = false;
    this.getMemberships();
  }

  closeChange(evt: any) {
    this.changeprimaryinstitution = false;
  }

  closeTerminate(evt: any) {
    this.terminatemembership = false;
    this.getMemberships();
  }

  closeTerminateCamp(evt: any) {
    this.terminatemembershipcamp = false;
    this.getMemberships();
  }

  addMembership() {
    this.addmembership = true;
  }

  changePrimaryInstitution() {
    this.doChangePrimaryInstitution.emit();
  }

  terminateMembership() {
    this.terminatemembership = true;
  }

  terminateMembershipCamp() {
    this.terminatemembershipcamp = true;
  }

  setAction(evt: any) {
    const val = evt.target.value;
    switch (val) {
      case 'addMembership': {
        this.addMembership();
        break;
      }
      case 'changePrimaryInstitution': {
        this.changePrimaryInstitution();
        break;
      }
      case 'terminateMembership': {
        this.terminateMembership();
        break;
      }
      case 'terminateMembershipCamp': {
        this.terminateMembershipCamp();
        break;
      }
    }
  }
}
